import EmObject from '@ember/object';

export const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const WEEKDAYS = DAYS.reject((day) => {
  return day === 'Sat' || day === 'Sun';
});

export const WEEKENDS = DAYS.filter((day) => {
  return day === 'Sat' || day === 'Sun';
});

export const DAY_ITEMS = [
  {
    label: 'any day',
    value: 'any',
  },
  {
    label: 'a weekday',
    value: 'weekdays',
  },
  {
    label: 'the weekend',
    value: 'weekends',
  },
  {
    label: 'specific days…',
    value: 'specific',
  },
];

export function daysToSet(string) {
  // Legacy data contains pipes instead of colons
  let days = string.split(/[:|]/);
  let set = {};

  DAYS.forEach((day) => (set[day] = days.includes(day)));

  return EmObject.create(set);
}

export function setToDays(set) {
  let days = [];

  DAYS.forEach((day) => {
    if (set.get(day)) {
      days.push(day);
    }
  });

  return days.join(':');
}

export function dayItemValue(days) {
  if (DAYS.every((day) => days.get(day))) {
    return 'any';
  }

  if (WEEKDAYS.every((day) => days.get(day)) && WEEKENDS.every((day) => !days.get(day))) {
    return 'weekdays';
  }

  if (WEEKENDS.every((day) => days.get(day)) && WEEKDAYS.every((day) => !days.get(day))) {
    return 'weekends';
  }

  return 'specific';
}
